import store from '@/store';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  disableErrorNotification: false,
});

store.$axios = instance;
